<template>
    <div class="register">
        <div class="heder">
            <p class="heder_test" v-if="type == 0">个人激活</p>
            <p class="heder_test" v-if="type == 1">企业激活</p>
        </div>
        <el-input
                v-if="type==0"
                class="input"
                v-model.trim="user.userAccount"
                prefix-icon="el-icon-my-newPhone"
                placeholder="请输入手机号码"
                maxlength="11"
        ></el-input>
        <el-input
                v-if="type==1"
                class="input"
                maxlength="40"
                v-model.trim="user.userAccount"
                placeholder="请输入企业邮箱"
                prefix-icon="el-icon-my-icon_email"
                @keyup.enter.native="KeyUpEnter"
        ></el-input>
        <div class="verifyCode">
            <el-input class="input" maxlength="6" prefix-icon="el-icon-my-icon_code" v-model="user.verifyCode"
                      @keyup.enter.native="KeyUpEnter" placeholder="请输入验证码"></el-input>
            <el-button :loading="loading"
                       @click="verify?send_sma():''"
                       :class="['butn',verify?'':'on']"
            >{{verify?'发送验证码':'已发送('+time+')'}}
            </el-button>
        </div>
        <el-input
                class="input userPassword"
                v-model.trim="user.userPassword"
                placeholder="请输入登录密码"
                maxlength="16"
                :type="passw"
                @input="password_dsafety"
                @blur="affirm_password_blur"
                @keyup.enter.native="KeyUpEnter"
        ><i slot="suffix" :class="icon" @click="showPass"></i></el-input>
        <div class="hint">请输入8—16位密码，由数字和字母组合（区分大小写）</div>
        <div class="passwor_dsafety">
            <div :class="{ on: dsafety>=1 }">弱</div>
            <div :class="{ on: dsafety>=2 }">中</div>
            <div :class="{ on: dsafety>=3 }">强</div>
        </div>
        <el-input
                @blur="affirm_password_blur"
                :class="['input','affirm_password',affirm==1?'affirm':'' ]"
                v-model="affirm_password"
                placeholder="确认登录密码"
                type="password"
                maxlength="16"
                @keyup.enter.native="KeyUpEnter"
        ></el-input>
        <div v-if="affirm==2" class="hint">新密码与确认密码不一致请重新输入</div>
        <el-button @click="register()" class="account-butn account-butn_0">激活</el-button>
        <div class="bottom-hint">
            <div class="protocol">
                <el-checkbox v-model="checked"></el-checkbox>
                同意 <span class="xiey" @click="Protocol = true">《用户注册协议》</span> <span class="xiey"
                                                                                     @click="uesrProtocol = true">《隐私政策》</span>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" v-dialogDrag title="用户协议" :visible.sync="Protocol" width="617" center>
            <div class="loding_test">
                <userProtocol></userProtocol>
            </div>
            <div style="text-align: center">
                <el-button class="account-butn" @click="Protocol=false">确认</el-button>
            </div>

        </el-dialog>
        <el-dialog :close-on-click-modal="false" v-dialogDrag title="用户协议" :visible.sync="uesrProtocol" width="617"
                   center>
            <div class="loding_test">
                <privacyProtocol></privacyProtocol>
            </div>
            <div style="text-align: center">
                <el-button class="account-butn" @click="uesrProtocol=false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userProtocol from "../userProtocol.vue";
    import privacyProtocol from "../privacyProtocol.vue";

    export default {
        data() {
            return {
                type: 0,
                id: '',
                user: {
                    userAccount: "",
                    userPassword: "",
                    verifyCode: ""
                },
                affirm_password: '',
                checked: false,
                loading: false,
                Protocol: false,
                uesrProtocol: false,
                time: 60,
                affirm: 0,
                dsafety: 0,
                verify: true,
                passw: "password",
                icon: "el-input__icon iconfont icon-xingzhuang1",
            };
        },
        components: {
            privacyProtocol,
            userProtocol,
        },
        created() {
            var pagename = window.top.document.URL
            var temp2 = pagename.split('?')[1];
            var pram2 = new URLSearchParams('?' + temp2);
            this.id = pram2.get('id')
            this.type = pram2.get('type')
        },
        methods: {
            password_dsafety(e) {
                this.dsafety = 0;
                if (e.length >= 8) {
                    var regNumber = /\d+/;
                    var regLower = /[a-z]+/;
                    var regUpper = /[A-Z]+/;
                    if (regNumber.test(e)) {
                        this.dsafety++;
                    }
                    if (regLower.test(e)) {
                        this.dsafety++;
                    }
                    if (regUpper.test(e)) {
                        this.dsafety++;
                    }
                }
            },
            affirm_password_blur() {
                if (this.user.userPassword != "" && this.affirm_password != "") {
                    if (this.user.userPassword == this.affirm_password) {
                        this.affirm = 1;
                    } else {
                        this.affirm = 2;
                    }
                } else {
                    this.affirm = 0;
                }
            },
            KeyUpEnter() {
                this.register();
            },
            showPass() {
                //点击图标是密码隐藏或显示
                if (this.passw == "text") {
                    this.passw = "password";
                    //更换图标
                    this.icon = "el-input__icon iconfont icon-xingzhuang1";
                } else {
                    this.passw = "text";
                    this.icon = "el-input__icon el-icon-view";
                }
            },
            register() {
                if (this.submit_verify()) {
                    this.$SIF.httpPost({
                        url: this.$SIF._serve.usermanage + '/activation/user',
                        data: {
                            ...this.user,
                            id: this.id,
                            userType: this.type,
                        },
                        succFun: res => {
                            this.$message({
                                message: '激活成功，立即跳往登录页面',
                                type: 'success'
                            });
                            this.$router.push({
                                name: "login"
                            })
                            // this.$confirm('激活成功，立即跳往登录页面？', '提示', {
                            //     confirmButtonText: '确定',
                            //     cancelButtonText: '取消',
                            //     type: 'warning'
                            // }).then(() => {
                            //     this.$router.push({
                            //         name:"login"
                            //     })
                            // });
                        }
                    });
                }
            },
            send_sma() {
                // if(!this.user.userAccount){
                //     this.$message({
                //         message: "请输入手机号/邮箱号",
                //         type: 'warning'
                //     });
                //     return
                // }
                this.loading = true
                if (this.type == 1) {
                    let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    let num = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
                    if (!reg.test(this.user.userAccount) && !num.test(this.user.userAccount)) {
                        this.$message({
                            message: "请输入正确企业邮箱号",
                            type: 'warning'
                        });
                        this.loading = false
                        return false;
                    }
                    this.loading = true
                    this.$SIF.sendByEmails({
                        params: {
                            templateId: 1,
                            toEmail: this.user.userAccount
                        },
                        succFun: res => {
                            this.verify_num();
                        }
                    });
                } else {
                    let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!reg.test(this.user.userAccount)) {
                        this.$message({
                            message: "请输入正确手机号",
                            type: 'warning'
                        });
                        this.loading = false
                        return false;
                    }
                    this.loading = true
                    this.$SIF.sendByPhone({
                        params: {
                            useWhere: 19,
                            toPhone: this.user.userAccount
                        },
                        succFun: res => {
                            this.verify_num();
                        }
                    });
                }
            },
            submit_verify() {
                var v = this.user;
                if (v.userAccount == "") {
                    if (this.type == 0) {
                        this.$message({
                            message: "请输入手机号",
                            type: 'warning'
                        });
                    } else {
                        this.$message({
                            message: "请输入企业邮箱",
                            type: 'warning'
                        });
                    }
                    return false;
                }
                if (v.userPassword == "" || this.affirm_password == '') {
                    this.$message({
                        message: "请输入密码",
                        type: 'warning'
                    });
                    return false;
                }
                let num = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
                if (!num.test(v.userPassword)) {
                    this.$message({
                        message: "请输入8-16位包含数字字母的密码",
                        type: 'warning'
                    });
                    return false;
                }
                if (v.userPassword != this.affirm_password) {
                    this.$message({
                        message: "两次密码输入不一致",
                        type: 'warning'
                    });
                    return false;
                }
                if (!this.checked) {
                    this.$message({
                        message: "我已阅读并同意《用户注册协议》 《隐私政策》,请确认",
                        type: "warning"
                    });
                    return;
                }
                return true;
            },
            verify_num() {
                var time = this.time;
                var that = this;
                var interval = setInterval(function () {
                    if (time <= 1) {
                        clearTimeout(interval);
                        that.verify = true;
                        that.loading = false
                        that.time = 60;
                    } else {
                        time--;
                        that.loading = false
                        that.verify = false;
                        that.time = time;
                    }
                }, 1000);
                this.verify = true;
                this.loading = true
            }
        }
    };
</script>
<style scoped type="text/css">
    .account-butn_0 {
        border: 1px solid rgba(25, 188, 115, 1);
        background: none;
        color: rgba(25, 188, 115, 1);
    }

    .account-butn_0:hover {
        background: rgba(25, 188, 115, 1);
        color: #ffffff;
    }

    .register {
        width: 100%;
        margin: 0 auto;
        text-align: center;
    }

    .hint {
        font-size: 12px;
        line-height: 26px;
        color: #ff1111;
    }

    .bottom-hint > div:first-child {
        margin-right: 10px;
    }

    .iconfont {
        display: block;
    }

    .heder {
        width: 100%;
        overflow: hidden;
    }

    .heder_test {
        font-size: 26px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 39px;
        letter-spacing: 1px;
        margin: 0;
        padding: 10px 0;
    }

    .bottom-hint {
        font-size: 12px;
        color: #fff;
        display: flex;
        line-height: 36px;
    }

    .el-checkbox:last-of-type {
        margin-right: 5px;
        display: inline-block;
    }

    .bottom-hint a {
        text-decoration: none;
    }

    .bottom-hint span {
        color: #19bc73;
    }

    .xiey {
        color: #19bc73;
        cursor: pointer;
    }

    .input.affirm_password .el-input__inner {
        padding-right: 40px;
    }

    .verifyCode .butn {
        width: 99px;
        height: 32px;
        border-radius: 5px;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.35);
        line-height: 32px;
        cursor: pointer;
        padding: 0;
        background: none;
    }

    .loding_test {
        height: 400px;
        overflow-y: auto;
    }

    .loding_test::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
    }

    .loding_test::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .loding_test::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }
</style>